import { call, put, select, takeLatest } from 'redux-saga/effects'
import { setBloodyShowOptions } from '../store/options.actions'
import { getServiceIdSelector } from '../../user/selectors'
import { OptionsService } from '../services/options.service'
import { IOptionsResponse } from '../../../common/common.types'
import { throwPcrException } from '../../pcr/store/pcr.actions'
import { ClientDataConstants } from '../../clientData/store/clientData.constants'

export function* getBloodyShowOptions() {
  const serviceId: string = yield select(getServiceIdSelector)
  const optionsService = new OptionsService(serviceId)
  try {
    const response: IOptionsResponse = yield call([optionsService, optionsService.getBloodyShowOptions])
    const { entity } = response

    yield put(setBloodyShowOptions(entity))
  } catch (e) {
    yield put(throwPcrException(`getBloodyShowOptions() error: ${e}`))
  }
}
export function* getBloodyShowOptionsSaga() {
  yield takeLatest([ClientDataConstants.ON_CLIENT_DATA_IMPORT_SUCCESS], getBloodyShowOptions)
}
